<template>
  <div class="upsert-custom-targeting">
    <div class="text-center">
      <h2 class="highlighted-color1">
        <span>{{ title }}</span>
      </h2>
    </div>
    <AlertWraper
      :content="content"
      :type="content_type"
    />
    <div>
      <UpsertCustomTargetingForm
        :advertiser="advertiser"
        :targeting="targeting"
        :type="type"
        @custom-targeting-created="handleSubmit"
        @custom-targeting-updated="handleSubmit"
        @upsert-custom-targeting-error="handleError"
      />
    </div>
  </div>
</template>

<script>
import NotificationService from '@/modules/notifications/services/notifications-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import UpsertCustomTargetingForm from '@/components/custom-targetings/UpsertCustomTargetingForm'

export default {
  name: 'UpsertCustomTargeting',
  components: {
    AlertWraper,
    UpsertCustomTargetingForm
  },
  props: {
    advertiser: {
      type: Object,
      required: true,
      description: 'Dados do anunciante para o formulário'
    },
    targeting: {
      type: Object,
      default: null,
      description: 'Dados do targeting (nulo para criação)'
    },
    type: {
      type: String,
      required: true,
      validator: value => ['SITE_LIST', 'EMAIL_AUDIENCE', 'APP_LIST'].includes(value),
      description: 'Tipo de targeting: SITE_LIST, APP_LIST ou EMAIL_AUDIENCE'
    }
  },
  data () {
    return {
      content: null,
      content_type: 'error'
    }
  },
  computed: {
    buttonText () {
      return this.targeting ? this.$t('save') : this.$t('create')
    },
    submitMessage () {
      if (this.type === 'SITE_LIST' || this.type === 'APP_LIST') {
        return this.targeting ? this.$t('list_edited_successfully') : this.$t('list_created_successfully')
      } else if (this.type === 'EMAIL_AUDIENCE') {
        return this.targeting ? this.$t('audience_edited_successfully') : this.$t('audience_created_successfully')
      }
      return ''
    },
    title () {
      if (this.type === 'SITE_LIST') {
        return this.targeting ? this.$t('edit_site_list') : this.$t('create_site_list')
      } else if (this.type === 'EMAIL_AUDIENCE') {
        return this.targeting ? this.$t('edit_audience') : this.$t('create_audience')
      } else if (this.type === 'APP_LIST') {
        return this.targeting ? this.$t('edit_app_list') : this.$t('create_app_list')
      }
      return ''
    }
  },
  methods: {
    handleError (error) {
      this.content = parseErrorResponseToArray(error)
    },
    handleSubmit (customTargeting) {
      const notification = {
        notification: {
          type: 'success',
          content: this.submitMessage
        }
      }
      NotificationService.createGlobalSuccessNotification(notification)
      if (this.targeting) {
        this.$emit('custom-targeting-updated', customTargeting)
      } else {
        this.$emit('custom-targeting-created', customTargeting)
      }
      this.reset()
    },
    reset () {
      this.content = null
    }
  }
}
</script>

<style scoped>
.upsert-custom-targeting {
  padding: 20px;
  margin: 0 auto;
  background-color: #fff;
}
.text-center {
  margin-bottom: 20px;
}
</style>
